<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="10" class="content_inner">
        <div class="margin-bottom-2x">
          <span @click="back" class="curson-pointer font-size-14 text-body-2"> <v-icon left style="margin-right: 0">mdi-chevron-left</v-icon>返回 </span>
        </div>
        <v-card class="form-card card-padding">
          <h2 class="card-title">{{ appCode ? "编辑应用" : "添加应用" }}</h2>
          <v-tabs v-model="tabValue">
            <v-tab key="base">基础信息</v-tab>
            <v-tab key="detail">配置图文介绍</v-tab>
            <v-tab key="extraConfig">安装配置</v-tab>
          </v-tabs>
          <v-card-text>
            <v-form v-model="valid" ref="form">
              <ul v-show="tabValue === 0" class="form-ul">
                <li class="required">
                  <span class="label">appCode：</span>
                  <div class="v-input-box">
                    <v-text-field ref="appCode" placeholder="请输入" v-model="form.appCode" solo required :rules="rules.appCode"></v-text-field>
                  </div>
                </li>
                <li class="required">
                  <span class="label">名称：</span>
                  <div class="v-input-box">
                    <v-text-field ref="appName" placeholder="请输入" v-model="form.appName" solo required :rules="rules.appName" :error-messages="errorMessages"></v-text-field>
                  </div>
                </li>
                <li class="required">
                  <span class="label">英文名：</span>
                  <div class="v-input-box">
                    <v-text-field ref="appNameEn" placeholder="请输入" v-model="form.appNameEn" solo required :rules="rules.appNameEn" :error-messages="errorMessages"></v-text-field>
                  </div>
                </li>
                <li>
                  <span class="label">简介：</span>
                  <div class="v-input-box">
                    <v-textarea ref="appDesc" rows="2" placeholder="请输入" v-model="form.appDesc" solo></v-textarea>
                  </div>
                </li>
                <li class="required">
                  <span class="label">用户类型：</span>
                  <div class="v-input-box">
                    <v-radio-group v-model="form.appUserType" mandatory row>
                      <v-radio label="用户" value="user"></v-radio>
                      <v-radio label="商户" value="mercacc"></v-radio>
                      <v-radio label="通用" value="common"></v-radio>
                    </v-radio-group>
                  </div>
                </li>
                <li class="required">
                  <span class="label">平台类型：</span>
                  <div class="v-input-box" v-if="platType.length > 0">
                    <div v-for="(item, key) in platType" :key="key" class="chieck-box-inline">
                      <v-checkbox v-model="platTypeValue" :label="item.name" :value="item.code" :rules="rules.platType" @change="changePlatType"></v-checkbox>
                    </div>
                  </div>
                </li>
                <!-- <li class="required" v-if="platTypeValue.includes('mobile')">
                  <span class="label">移动端平台类型：</span>
                  <div class="v-input-box" >
                    <div v-for="(item, key) in mobilePlat" :key="key" class="chieck-box-inline">
                      <v-checkbox v-model="mobileValue" :label="item.name" :value="item.code" ></v-checkbox>
                    </div>
                    <p> (默认全部支持)</p>
                  </div>
                </li> -->
                <!-- <v-file-input accept="image/*"
                        label="File input"
                        prepend-icon="mdi-file-image"
                        @change="changeFileaaa"
                      ></v-file-input> -->
                <li class="li-file" v-if="img.length > 0">
                  <span class="label">图标：</span>
                  <div class="v-input-box">
                    <div class="upload-box" v-for="(itemUpload, key) in img" :key="key">
                      <div class="inner">
                        <p style="font-size: 12px">{{ itemUpload.name }}</p>
                        <v-avatar class="img" size="62">
                          <img v-if="itemUpload.src" :src="imgSrcTimestamp(itemUpload.src)" alt="John" />
                          <v-icon v-else x-large>mdi-camera</v-icon>
                        </v-avatar>
                      </div>
                      <v-file-input v-model="itemUpload.file" @change="changeFileImg(itemUpload)" filled accept="image/png, image/jpeg, image/bmp" prepend-icon="mdi-camera" solo></v-file-input>
                      <span class="delete" @click="deleteImg(key)">删除</span>
                    </div>
                  </div>
                </li>
                <li class="li-url" v-if="url.length > 0">
                  <span class="label">应用地址:</span>
                  <div class="v-input-box">
                    <div v-for="(item, key) in url" :key="key">
                      <h4 style="margin-top: 6px">{{ item.name }}</h4>
                      <div v-if="item.children.length > 0" class="input-group-nomargin">
                        <div v-for="(o, key) in item.children" :key="key">
                          <template >
                              <v-text-field v-if="o.appIdRequired === 0 && o.routingParameters === 0" ref="name" placeholder="请输入" v-model="o.url" solo>
                                <template v-slot:prepend-inner>
                                  <span>{{ o.name }}</span>
                                </template>
                              </v-text-field>
                              <div v-else class="file-group">
                                <div class="file-group-title">
                                  <span>{{ o.name }}</span>
                                </div>
                                <v-text-field v-if="o.appIdRequired === 1" ref="name" class="no-bottom-field" placeholder="请输入Appid" v-model="o.appId" solo></v-text-field>
                                <v-text-field ref="name" class="no-bottom-field-next" placeholder="请输入页面路径" v-model="o.url" solo></v-text-field>
                                <v-text-field ref="name" v-if="o.routingParameters === 1" class="no-bottom-field" placeholder="请输入route" v-model="o.route" solo></v-text-field>
                              </div>
                          </template>
                        </div>
                      </div>
                      <div v-else style="overflow: hidden">
                        <v-text-field v-if="item.appIdRequired === 0 && item.routingParameters === 0" ref="name" placeholder="请输入" v-model="item.url" solo>
                          <template v-slot:prepend-inner>
                            <span>{{ item.name }}</span>
                          </template>
                        </v-text-field>
                        <div v-else class="file-group">
                          <div class="file-group-title">
                            <span>{{ item.name }}</span>
                          </div>
                          <v-text-field v-if="item.appIdRequired === 1" ref="name" class="no-bottom-field" placeholder="请输入Appid" v-model="item.appId" solo></v-text-field>
                          <v-text-field ref="name" class="no-bottom-field-next" placeholder="请输入页面路径" v-model="item.url" solo></v-text-field>
                          <v-text-field v-if="item.routingParameters === 1" ref="name" class="no-bottom-field" placeholder="请输入route" v-model="item.route" solo></v-text-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="chekbox-notip margin-bottom-2x" v-if="platTypeValue.indexOf('selfService') !== -1">
                  <span class="label">认证方式：</span>
                  <div class="v-input-box">
                    <div v-for="(item, key) in authMethodsConfig" :key="key" class="chieck-box-inline">
                      <v-checkbox v-model="authMethods" :label="item.name" :value="item.id"></v-checkbox>
                    </div>
                  </div>
                </li>
                <li>
                  <span class="label">接口地址：</span>
                  <div class="v-input-box">
                    <v-text-field ref="name" placeholder="请输入" v-model="form.webApi" solo></v-text-field>
                  </div>
                </li>
                <li>
                  <span class="label">是否显示app头：</span>
                  <div class="v-input-box">
                    <v-switch v-model="showTitle" :true-value="1" :false-value="0"></v-switch>
                  </div>
                </li>
                <li>
                  <span class="label">是否需要登录：</span>
                  <div class="v-input-box"><v-switch v-model="form.loginRequired" :true-value="1" :false-value="0"></v-switch></div>
                </li>
                <li>
                  <span class="label">是否允许克隆：</span>
                  <div class="v-input-box"><v-switch v-model="isAllowClone"></v-switch></div>
                </li>
                <li>
                  <span class="label">是否支持方案：</span>
                  <div class="v-input-box"><v-switch v-model="form.supportSchedule" :true-value="1" :false-value="0"></v-switch></div>
                </li>
                <li>
                  <span class="label">是否允许绑定快捷应用：</span>
                  <div class="v-input-box"><v-switch v-model="isShortcut" :true-value="1" :false-value="0"></v-switch></div>
                </li>
                <li>
                  <span class="label">状态：</span>
                  <div class="v-input-box"><v-switch v-model="form.status" :true-value="1" :false-value="0"></v-switch></div>
                </li>
              </ul>
              <div v-show="tabValue === 1" class="editor-content">
                <div v-if="isEditorShow" style="border: 1px solid #ccc">
                  <Toolbar style="border-bottom: 1px solid #ccc" :editorId="editorId" :defaultConfig="toolbarConfig" :mode="mode" />
                  <Editor ref style="height: 500px; overflow-y: hidden" :editorId="editorId" :defaultConfig="editorConfig" :defaultContent="getDefaultContent" :defaultHtml="form.richText" :mode="mode" @onChange="onChangeEditor" />
                </div>
              </div>
              <div v-show="tabValue === 2" class="stepConfig-content">
                <div class="text-right designer-top">
                  <div class="text-left designer-tips">
                    <span class="tip-title">注:</span>
                    <p><span class="font-weight-bold">添加，编辑，删除接口配置方法：</span><span class="text-orange">step1:</span>点击“按钮组”; <span class="text-orange">step2:</span>点击“查看Json”, 修改每个按钮的action(接口地址)，method(请求方式)等字段，复制整段json;<span class="text-orange">step3:</span>点击“导入Json” ,粘贴以上json。</p>
                  </div>
                  <v-btn class="ma-2 white--text" small outlined color="blue" @click="importJsonDialog = true">导入Json</v-btn>
                  <v-btn class="ma-2 white--text" small outlined color="blue" @click="getJson">查看Json</v-btn>
                </div>
                <fc-designer ref="designer">
                  <template slot="handle">
                    <ElButton @click="addSubmitBtn" round type="warning" plain>按钮组（添加，编辑，删除）</ElButton>
                  </template>
                </fc-designer>
                <!-- <div>66666</div>
                <div v-if="rule">rule:{{rule}}
                  <form-create :rule="rule" v-model="fApi" :option="options"/>
                </div> -->
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn large class="ma-2 white--text btn-large" color="blue" style="margin: 0 auto !important" @click="submit">确定</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="jsonDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">查看Json</span>
        </v-card-title>
        <v-card-text class="pb-0 jsoneditor-vue-content">
          <vue-json-editor v-model="installConfig" :show-btns="false" :mode="'code'" lang="zh"></vue-json-editor>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="normal" @click="jsonDialog = false" text>取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="importJsonDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">导入Json</span>
        </v-card-title>
        <v-card-text class="pb-0 jsoneditor-vue-content">
          <vue-json-editor v-model="importInstallConfig" :show-btns="true" :mode="'code'" lang="zh" @json-save="onJsonSave"></vue-json-editor>
        </v-card-text>
        <v-card-actions class="footer-jsonedittor">
          <v-spacer></v-spacer>
          <v-btn color="normal" @click="importJsonDialog = false" text>取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// import { mapState } from 'vuex'
import { buildAxios } from '@/plugins/axios'
import { handleResponse } from '@/plugins/errorHandler'
import { imgSrcTimestamp } from '@/plugins/utils'
import '@wangeditor/editor/dist/css/style.css'
import { Editor, Toolbar, getEditor, removeEditor } from '@wangeditor/editor-for-vue'
import cloneDeep from 'lodash.clonedeep'
import vueJsonEditor from 'vue-json-editor'
export default {
  components: {
    Editor,
    Toolbar,
    vueJsonEditor
    // VueEditor
  },
  data () {
    return {
      menu: [{
        title: '分组1',
        name: 'group1',
        list: [{
          icon: 'icon-checkbox',
          name: 'checkbox',
          label: '单选框'
        }]
      }],
      editorId: `w-e-${Math.random().toString().slice(-5)}`, // 【注意】编辑器 id ，要全局唯一
      toolbarConfig: {},
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            base64LimitSize: 10 * 1024 * 1024 // 10M 以下插入 base64
          }
        }
      },
      mode: 'simple', // or 'simple'
      // defaultContent （JSON 格式） 和 defaultHtml（HTML 格式）二选一
      defaultContent: [],
      defaultHtml: '',
      tabValue: 0,
      editorOption: {},
      errorMessages: '',
      installConfig: {},
      importInstallConfig: [],
      valid: true,
      rules: {
        appCode: [
          v => !!v || '请填写appCode',
          v => v.length <= 50 || 'appCode 不能超过50个字符长度'
        ],
        appName: [
          v => !!v || '请填写应用名称'
        ],
        appNameEn: [
          v => !!v || '请填写应用英文名称'
        ],
        platType: [
          v => v.length >= 1 || '请选择平台类型'
        ]
        // appIconFile: [
        //   v => !!v || '请上传应用图标'
        // ],
        // pcIconFile: [
        //   v => !!v || '请上传应用图标'
        // ]
      },
      form: {
        appCode: '',
        appDesc: '',
        appIconFile: '',
        pcIconFile: '',
        appName: '',
        appNameEn: '',
        appUserType: '', // 1用户  2商户， 3 通用
        extraConfig: {},
        richText: '',
        route: '',
        webApi: '',
        appType: 0, // 应用类型，默认传0
        platType: '',
        loginRequired: 1,
        authMethods: '',
        supportSchedule: 0,
        status: 1
      },
      platTypeValue: [],
      appCode: this.$route.query.appCode,
      info: {},
      isEditorShow: false,
      jsonDialog: false,
      fApi: {},
      options: {
        onSubmit: (formData) => {
          alert(JSON.stringify(formData))
        }
      },
      rule: [
        {
          type: 'input',
          field: 'input1',
          title: 'input1',
          value: ''
        },
        {
          type: 'input',
          field: 'input2',
          title: 'input2',
          value: ''
        },
        {
          type: 'input',
          field: 'input3',
          title: 'input3',
          value: '',
          control: [
            {
              handle: (val) => !!val,
              append: 'input1',
              rule: [
                {
                  type: 'input',
                  field: 'input4',
                  title: 'input4',
                  value: ''
                }
              ]
            }
          ]
        }
      ],
      importJsonDialog: false,
      img: [],
      url: [],
      showTitle: 1,
      btnConfig: [
        {
          type: 'el-button',
          children: [
            'submit-add'
          ],
          effect: {
            fetch: {
              action: '',
              method: 'POST',
              data: {},
              headers: {},
              to: 'options'
            }
          },
          _fc_drag_tag: 'el-button',
          hidden: false,
          display: false
        }, {
          type: 'el-button',
          children: [
            'submit-edit'
          ],
          effect: {
            fetch: {
              action: '',
              method: 'POST',
              data: {},
              headers: {},
              to: 'options'
            }
          },
          _fc_drag_tag: 'el-button',
          hidden: false,
          display: false
        }, {
          type: 'el-button',
          children: [
            'submit-delete'
          ],
          effect: {
            fetch: {
              action: '',
              method: 'POST',
              data: {},
              headers: {},
              to: 'options'
            }
          },
          _fc_drag_tag: 'el-button',
          hidden: false,
          display: false
        }],
      json: {
        msg: 'demo of jsoneditor'
      },
      authMethodsConfig: [],
      authMethods: [],
      isAllowClone: false,
      isShortcut: false,
      mobilePlat: [],
      mobileValue: []
    }
  },
  computed: {
    // ...mapState(['platTypeList']),
    platType () {
      return this.$store.state.platTypeList
    },
    platTypeLevel () {
      return this.$store.state.platTypeLevel
    },
    getDefaultContent () {
      return cloneDeep(this.defaultContent) // 【注意】深度拷贝 defaultContent ，否则会报错
    }
  },
  watch: {
  },
  beforeDestroy () {
    const editor = getEditor(this.editorId)
    if (editor == null) return
    editor.destroy()
    removeEditor(this.editorId)
  },
  created () {
  },
  mounted () {
    this.mobilePlat = this.platType.find(item => { return item.code === 'mobile' }).children
    console.log('platType-------123', this.mobilePlat)
    this.authMethodsConfig = window.authMethodsConfig
    if (this.appCode) {
      this.getHistory()
    } else {
      this.isEditorShow = true
    }
  },
  methods: {
    imgSrcTimestamp,
    back () {
      this.$router.back(-1)
    },
    addSubmitBtn () {
      console.log('111111111112111', this.$refs.designer.getRule(), this.btnConfig)
      let arr = this.$refs.designer.getRule()
      arr = arr.concat(this.btnConfig)
      this.$refs.designer.setRule(arr)
      // const btnObj = arr.find(item => { return item.type === 'el-button' && item.children[0] === 'submit' })
      // if (!btnObj) {
      // }
    },
    // platType
    changePlatType (val) {
      console.log(val, 'val------------')
      const list = this.platType.filter(item => {
        return val.indexOf(item.code) !== -1
      })
      this.initImg(list)
      this.initUrl(list)
    },
    initImg (list) {
      const arr = []
      list.forEach(item => {
        const isExist = this.img.findIndex(o => {
          return item.code === o.code
        })
        if (isExist > -1) {
          arr.push(this.img[isExist])
        } else {
          const obj = {
            code: item.code,
            name: item.name,
            src: '',
            file: null
          }
          arr.push(obj)
        }
      })
      this.img = arr
    },
    initUrl (list) {
      const arr = []
      list.forEach(item => {
        const isExist = this.url.findIndex(o => {
          return item.code === o.code
        })
        if (isExist > -1) {
          arr.push(this.url[isExist])
        } else {
          arr.push(item)
        }
      })
      this.url = arr
    },
    onJsonSave (value) {
      this.$refs.designer.setRule(value)
      this.importJsonDialog = false
    },
    // form-careate
    getJson () {
      // this.installConfig = this.$refs.designer.getJson()
      this.installConfig = this.$refs.designer.getRule()
      this.jsonDialog = true
    },
    onChangeEditor (editor) {
      this.form.richText = editor.getHtml()
    },
    // upload
    changeFileImg (item) {
      if (item.file) {
        const fileReader = new FileReader()
        fileReader.readAsDataURL(item.file)
        fileReader.onload = (e) => {
          item.src = e.target.result
        }
        this.uploadFile(item)
      }
    },
    uploadFile (item) {
      const request = buildAxios()
      const formData = new FormData()
      if (!this.form.appCode) {
        this.$emit('alert', {
          msg: '请先输入应用code！',
          type: 'error'
        })
        return false
      }
      formData.append('iconName', this.form.appCode + item.code)
      formData.append('iconType', 'app')
      formData.append('file', item.file)
      request.defaults.headers['content-type'] = 'multipart/form-data'
      request.post('baseIcon/addIcon', formData).then(res => {
        item.src = res.data.data.url
      }).catch(reason => {
        this.$emit('alert', {
          msg: handleResponse(reason.response),
          type: 'error'
        })
      })
    },
    deleteImg (index) {
      this.img[index].file = null
      this.img[index].src = ''
    },
    // submit
    submit () {
      // this.rule = this.$refs.designer.getRule()
      if (!this.$refs.form.validate()) {
        this.$emit('alert', {
          msg: '表单填写有误！',
          type: 'error'
        })
      } else {
        console.log('img', this.img)
        const extraConfig = {
          img: this.img,
          url: this.url,
          installConfig: this.$refs.designer.getRule(),
          showTitle: this.showTitle,
          isAllowClone: this.isAllowClone,
          isShortcut: this.isShortcut
        }
        this.form.platType = this.platTypeValue.join(',')
        this.form.extraConfig = extraConfig
        // const arr = this.authMethodsConfig.filter(item => {
        //   return this.authMethods.indexOf(item.key) !== -1
        // })
        this.form.authMethods = this.authMethods.join(',')
        const formData = new FormData()
        Object.keys(this.form).forEach((key) => {
          if (this.form[key]) {
            formData.append(key, this.form[key])
          }
        })
        if (this.appCode) {
          this.editSubmit(this.form)
        } else {
          this.addSubmit(this.form)
        }
      }
    },
    // add
    addSubmit (formData) {
      const request = buildAxios()
      // request.defaults.headers['content-type'] = 'multipart/form-data'
      request.post('baseApp/add', formData).then(res => {
        this.$router.push({ name: 'appList' })
      }).catch(reason => {
        this.$emit('alert', {
          msg: handleResponse(reason.response),
          type: 'error'
        })
      })
    },
    // edit
    editSubmit (formData) {
      const request = buildAxios()
      // request.defaults.headers['content-type'] = 'multipart/form-data'
      request.post('baseApp/update', formData).then(res => {
        this.$router.push({ name: 'appList' })
      }).catch(reason => {
        this.$emit('alert', {
          msg: handleResponse(reason.response),
          type: 'error'
        })
      })
    },
    getHistory () {
      const request = buildAxios()
      request.get('baseApp/getOne?appCode=' + this.appCode).then(res => {
        this.info = res.data.data
        this.form = {
          appCode: this.info.appCode,
          appIconFile: this.info.appIconFile,
          pcIconFile: this.info.pcIconFile,
          appName: this.info.appName,
          appNameEn: this.info.appNameEn,
          appUserType: this.info.appUserType,
          extraConfig: this.info.extraConfig,
          richText: this.info.richText,
          route: this.info.route,
          webApi: this.info.webApi,
          appType: 0,
          appDesc: this.info.appDesc,
          platType: this.info.platType,
          url: this.info.extraConfig.url,
          loginRequired: this.info.loginRequired,
          supportSchedule: this.info.supportSchedule,
          status: this.info.status
        }
        this.showTitle = this.info.extraConfig.showTitle
        this.isAllowClone = !!this.info.extraConfig.isAllowClone
        this.isShortcut = !!this.info.extraConfig.isShortcut
        this.platTypeValue = this.info.platType ? this.info.platType.split(',') : []
        if (this.platTypeValue.length > 0) {
          this.changePlatType(this.platTypeValue)
        }
        this.isEditorShow = true
        this.img = this.info.extraConfig.img || []
        // const urlInit = []
        // this.info.extraConfig.url.forEach(element => {
        //   console.log('element', element)
        //   if (element.children && element.children.length > 0) {
        //     element.children.forEach((item, i) => {
        //       const o = this.platTypeLevel.find(ol => {
        //         return ol.code === item.code
        //       })
        //       element.children[i] = { ...item, ...o }
        //       console.log(222, item, o, element.children[i])
        //     })
        //   } else {
        //     const o = this.platTypeLevel.find(ol => {
        //       return ol.code === element.code
        //     })
        //     element = { ...element, ...o }
        //   }
        // })
        // this.url = this.info.extraConfig.url || []
        let urlList = []
        this.info.extraConfig.url.forEach(o => {
          urlList = urlList.concat(o.children && o.children.length > 0 ? o.children : o)
        })
        this.url = []
        this.platType.forEach(pitem => {
          let item = JSON.parse(JSON.stringify(pitem))
          if (this.info.platType.includes(item.code)) {
            if (item.children && item.children.length > 0) {
              item.children = item.children.map(o => {
                const uhc = urlList.find(u => { return u.code === o.code }) || {}
                return { ...uhc, ...o }
              })
            } else {
              const uh = urlList.find(u => { return u.code === item.code }) || {}
              item = { ...uh, ...item }
            }
            this.url.push(item)
          }
        })
        if (this.info.extraConfig.installConfig) {
          this.$refs.designer.setRule(this.info.extraConfig.installConfig)
        }
        if (this.info.authMethods) {
          this.authMethods = this.info.authMethods.split(',')
        }
        //  else {
        //   this.authMethods = this.authMethodsConfig.map(item => {
        //     return item.key
        //   })
        // }
        // this.form.loginRequired = 1
        // this.showTitle = 1
      }).catch(reason => {
        this.$emit('alert', {
          msg: handleResponse(reason.response) + 'kkkkk',
          type: 'error'
        })
      })
    }
  }
}
</script>
<style>
.font-weight-bold {
  color: #e6a23c;
}
.jsoneditor-vue-content .jsoneditor-vue {
  height: 400px;
}
.jsoneditor-poweredBy {
  display: none;
}
.json-save-btn {
  position: absolute;
  right: 20px;
  padding: 7px 19px;
}
.footer-jsonedittor .v-btn {
  transform: translate(-100px, -7px);
  background-color: rgb(233, 233, 233);
}
.designer-top .designer-tips {
  padding-left: 23px;
  position: relative;
}
.designer-top .text-orange {
  color: #e6a23c;
  padding-left: 3px;
}
.designer-top .designer-tips .tip-title {
  position: absolute;
  top: -1px;
  left: 0;
}
.designer-top .designer-tips p {
  line-height: 20px;
  margin-bottom: 0;
}
.chekbox-notip .chieck-box-inline .v-input__control .v-messages {
  display: none;
}
.form-ul {
  width: 635px;
}
</style>
